export const createAccountOTTERIACMResponseSaga = (state) => state.accountServiceReducer.createAccountResponse;
export const createAdminAccountResponseSaga = (state) => state.accountServiceReducer.createAdminAccountResponse;
export const apiLoadingInProgressSaga = (state) => state.accountServiceReducer.apiLoadingInProgress;
